import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EReportActions } from '../../constants/actionTypes/report';
import { EReportStatus } from '../../constants/report';

export const toggleReportStatus = actionGenerator<EReportActions.TOGGLE_REPORT_STATE, EReportStatus>(
  EReportActions.TOGGLE_REPORT_STATE,
);
export const toggleSaveReportLoading = actionGenerator<EReportActions.TOGGLE_LOADING, boolean>(
  EReportActions.TOGGLE_LOADING,
);
export const toggleSaveReportError = actionGenerator<EReportActions.TOGGLE_ERROR, string>(EReportActions.TOGGLE_ERROR);
export const setShareReportUrl = actionGenerator<EReportActions.SET_SHARE_REPORT_URL, string>(
  EReportActions.SET_SHARE_REPORT_URL,
);

export type TToggleReportStatusAction = ReturnType<typeof toggleReportStatus>;
export type TToggleSaveReportLoadingAction = ReturnType<typeof toggleSaveReportLoading>;
export type TToggleSaveReportErrorAction = ReturnType<typeof toggleSaveReportError>;
export type TSetShareReportUrlAction = ReturnType<typeof setShareReportUrl>;

export type TReportActions =
  | TToggleReportStatusAction
  | TToggleSaveReportLoadingAction
  | TToggleSaveReportErrorAction
  | TSetShareReportUrlAction;
